module.exports = __webpack_public_path__ + "static/media/BM_Alerts.6f6b91c7.svg";